import { render, staticRenderFns } from "./operationalReportsForCorporate.vue?vue&type=template&id=2b030a2d&scoped=true&"
import script from "./operationalReportsForCorporate.vue?vue&type=script&lang=js&"
export * from "./operationalReportsForCorporate.vue?vue&type=script&lang=js&"
import style0 from "./operationalReportsForCorporate.vue?vue&type=style&index=0&id=2b030a2d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b030a2d",
  null
  
)

export default component.exports